// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { connect } from 'react-redux'
import { func, object, string } from 'prop-types'
import SelectDynamic from './SelectDynamic'

// because English doesn't like consistency when pluralizing words
const valueKeys = {
  'antennaApplications': 'antennaApplication',
  'antennaClassifications': 'classification',
  'antennaCompliances': 'compliance',
  'antennaStatuses': 'status',
  'antennaPolarizations': 'polarizationCapability',
  'antennaModes': 'mode',
  'bands': 'band',
  'licenseBases': 'licenseBasis',
  'passiveRepeaterTypes': 'type',
  'radioServices': 'radioService',
  'stationClasses': 'stationClass',
}

class SelectFromState extends React.Component {
  static propTypes = {
    className: string,
    decoration: func,
    id: string.isRequired,
    input: object.isRequired,
    options: object.isRequired,
    selectLabel: string,
  }

  render () {
    const { props } = this

    const {
      className = '',
      id,
      input: { value },
      selectLabel,
    } = this.props

    return (
      <div className={`select-from-state ${className}`}>
        { selectLabel && <label id={`${id}-label`}>{selectLabel}</label> }
        <SelectDynamic {...props} />
        { props.decoration && <props.decoration value={value} /> }
      </div>
    )
  }
}

// this is currently only needed for lists from domain state
// can add logic for other slices of state if need be
// TODO / NOTE: the reason for supporting targetSets as arrays strings
// which map to valueKeys is because the this redux store has become
// large enough that the mapped Lists in valueKeys need to be nested.
// once this is in place, valueKeys will be removed.
// TODO - once the above is done, also make the mapping
// of valueKeyRoot more intelligent like RadioGroupFromState for it's label/values
const mapStateToProps = ({ domain }, { targetSet, valueKeyRoot }) => {
  const isNested = Array.isArray(targetSet)

  const options = (
    isNested
      ? domain.getIn(targetSet)
      : domain.get(targetSet)
  )

  const label = valueKeyRoot || `${valueKeys[targetSet]}`

  const valueKey = (
    valueKeyRoot
      ? `${valueKeyRoot}Id`
      : `${valueKeys[targetSet]}Id`
  )

  return {
    label,
    options,
    valueKey,
  }
}

export default connect(mapStateToProps)(SelectFromState)
